import React, { useState, useEffect } from 'react';

import {
  getUsers,
  addUser,
  updateUser,
  deleteUser,
} from '../../../services/userService';

import ContentChangeButton from '../../../components/admin/buttons/ContentChangeButton/ContentChangeButton';
import AdminUserCard from '../../../components/admin/cards/AdminUserCard/AdminUserCard';
import UserModal from '../../../components/admin/modals/UserModal/UserModal';
import ConfirmDeleteModal from '../../../components/admin/modals/ConfirmDeleteModal/ConfirmDeleteModal';

import './AdminUsers.css';

const AdminUser = ({ currentUser }) => {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editModalMode, setEditModalMode] = useState('edit');

  // Users Admin Page
  const getAllUsers = async () => {
    const allUsers = await getUsers();
    setUsers(allUsers);
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const onAddClickHandler = () => {
    setSelectedUser({});
    setEditModalMode('add');
    setIsEditModalOpen(true);
    setIsDeleteModalOpen(false);
  };

  const onEditClickHandler = (user) => {
    setSelectedUser(user);
    setEditModalMode('edit');
    setIsEditModalOpen(true);
    setIsDeleteModalOpen(false);
  };

  const onDeleteClickHandler = (user) => {
    setSelectedUser(user);
    setIsDeleteModalOpen(true);
    setIsEditModalOpen(false);
  };

  const onModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedUser(null);
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setSelectedUser(null);
  };

  const handleSubmit = async (formData) => {
    try {
      if (editModalMode === 'edit') {
        await updateUser(selectedUser._id, formData);
        alert('Success! Your user has been updated successfully!');
      } else {
        await addUser(formData);
        alert('Success! Your user has been created successfully!');
      }

      await getAllUsers();
      setIsEditModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const onConfirmDelete = async () => {
    await deleteUser(selectedUser._id);
    await getAllUsers();
    onDeleteModalClose();
    alert(`Deleted! ${selectedUser.userName} deleted successfully!`);
  };

  return (
    <div id='admin-user-container'>
      <div className='admin-wrapper'>
        <div className='admin-user-title-add-user-container'>
          <h1 id='user-list-title'>Users</h1>
          <ContentChangeButton
            iconType='add'
            size='large'
            width='long'
            onClickHandler={onAddClickHandler}
          >
            Add User
          </ContentChangeButton>
        </div>
        <div className='admin-comp-container'>
          {users.map((a, i) => (
            <AdminUserCard
              key={i}
              user={a}
              currentUser={currentUser}
              onEditClickHandler={onEditClickHandler}
              onDeleteClickHandler={onDeleteClickHandler}
              isButtonsDisabled={!currentUser.isAdmin}
              isDeleteButtonDisabled={a._id === currentUser._id}
            />
          ))}
        </div>
      </div>
      {isEditModalOpen && (
        <UserModal
          onClose={onModalClose}
          onSubmit={handleSubmit}
          user={selectedUser}
          mode={editModalMode}
        />
      )}
      {isDeleteModalOpen && (
        <ConfirmDeleteModal
          onClose={onDeleteModalClose}
          onConfirm={onConfirmDelete}
          deleteItemTitle={selectedUser?.userName}
        />
      )}
    </div>
  );
};

export default AdminUser;
